import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  // Synchronously focus the editor and pre-fill the reply mention so the iOS
  // Safari virtual keyboard opens within the user-gesture stack.
  reply({ params: { frameId, userId, displayName } }) {
    this.#focusEditor(frameId);
    this.#insertMention(frameId, userId, displayName);
  }

  #focusEditor(frameId) {
    const frame = document.getElementById(frameId);
    frame?.querySelector("[contenteditable]")?.focus();
  }

  #insertMention(frameId, userId, displayName) {
    const frame = document.getElementById(frameId);
    const editorEl = frame?.querySelector("[data-controller*='comment-editor']");
    if (!editorEl || !displayName) return;

    editorEl.dispatchEvent(
      new CustomEvent("comment-editor:insert-mention", {
        bubbles: false,
        detail: { displayName, userId },
      })
    );
  }
}
